export default "__VITE_ASSET__DAzP5Xfg__"